import { useMemo } from 'react';

type OptionLike = { value: string; label: string; group?: string };

export function useOptionsGroups<T extends OptionLike>(options: T[], groupOrder?: string[]) {
    return useMemo(() => {
        const ungrouped: T[] = [];
        const groupMap = new Map<string, T[]>();
        for (const option of options) {
            if (option.group) {
                if (!groupMap.has(option.group)) groupMap.set(option.group, []);
                groupMap.get(option.group)!.push(option);
            } else {
                ungrouped.push(option);
            }
        }
        const seen = new Set<string>();
        const ordered: Array<[string, T[]]> = [];
        if (groupOrder) {
            for (const name of groupOrder) {
                const items = groupMap.get(name);
                if (items) {
                    ordered.push([name, items]);
                    seen.add(name);
                }
            }
        }
        const remaining = [...groupMap.keys()].filter((k) => !seen.has(k)).sort();
        for (const name of remaining) ordered.push([name, groupMap.get(name)!]);
        return { ungrouped, groups: ordered };
    }, [options, groupOrder]);
}
